import { PickerRange, toIsoPeriod, toPickerRange } from "@/utils/date-range";

import { EMPTY_VOUCHER_RANGE } from "../constants";
import { DateRange } from "../types";
import { VoucherDateRangePicker } from "./voucher-date-range-picker";

interface DateRangeInputsProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

export function DateRangeInputs({
  value,
  onChange,
}: DateRangeInputsProps): JSX.Element {
  return (
    <VoucherDateRangePicker
      value={toPickerRange(value)}
      onChange={(range?: PickerRange): void => onChange(toIsoPeriod(range))}
      onClear={(): void => onChange({ ...EMPTY_VOUCHER_RANGE })}
      className="h-10"
    />
  );
}
